import axios from 'axios';
import { adaptImMonitoringFilters } from './adapters/filterAdapters';
import errorHandlerFactory from './errorHandler';

const errorHandler = errorHandlerFactory('An error occured when fetching IM Monitoring data.');

// eslint-disable-next-line import/prefer-default-export
export const fetchImMonitoring = (filters = []) => {
    const filterObject = adaptImMonitoringFilters(filters);
    const params = {};

    Object.entries(filterObject).forEach(
        // eslint-disable-next-line no-return-assign
        ([key, value]) => {
            switch (key) {
                case 'counterparty': {
                    value.forEach((cpty) => {
                        params[key] = params[key] || [];
                        params[key].push(btoa(cpty));
                    });
                    break;
                }
                default: params[key] = value;
            }
        }
    );

    if (!(Object.entries(filterObject).length === 0)) {
        return axios.post('/Csa/ImCharting', params)
            .then(r => r.data).catch(errorHandler);
    }
    throw Error('A date filter is required');
};
